module.exports = __webpack_public_path__ + "h5/img/icon_05.feed0b12.png";